import { render, staticRenderFns } from "./SettingsSportsTypes.vue?vue&type=template&id=77204b9a&"
import script from "./SettingsSportsTypes.vue?vue&type=script&lang=js&"
export * from "./SettingsSportsTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports